export function objectProcessingKey({ activityId = null, shapeId = null } = {}) {
  const aid = String(activityId || '').trim();
  if (aid) return `activity:${aid}`;
  return String(shapeId || '').trim();
}

function pushTarget(out, seen, target) {
  const key = target?.key || objectProcessingKey(target);
  if (!key || seen.has(key)) return;
  seen.add(key);
  out.push({
    key,
    activityId: String(target?.activityId || '').trim() || null,
    shapeId: String(target?.shapeId || '').trim() || null,
  });
}

/**
 * Resolve user pins, AI pins, and pasted evidence into overlay targets.
 */
export function collectObjectProcessingTargets({
  activityIds = [],
  aiPins = [],
  canvasEvidences = [],
  placeActivityIds = [],
} = {}) {
  const out = [];
  const seen = new Set();

  for (const id of [...(activityIds || []), ...(placeActivityIds || [])]) {
    const activityId = String(id || '').trim();
    if (activityId) pushTarget(out, seen, { activityId });
  }

  for (const pin of aiPins || []) {
    if (!pin) continue;
    pushTarget(out, seen, {
      shapeId: pin.shapeId || pin.id,
      activityId: pin.activityId,
    });
  }

  for (const evidence of canvasEvidences || []) {
    const shapeId = String(evidence?.shapeId || '').trim();
    if (shapeId) pushTarget(out, seen, { shapeId });
  }

  return out;
}

export function objectProcessingLabel(phase, messages) {
  const key = String(phase || '').trim();
  return messages?.objectProcessing?.[key] || '';
}

export function normalizeProcessingTargets(targets = []) {
  const list = Array.isArray(targets) ? targets : [targets];
  const out = [];
  const seen = new Set();
  for (const item of list) {
    if (!item) continue;
    if (typeof item === 'string') {
      const key = item.trim();
      if (!key) continue;
      if (key.startsWith('activity:')) {
        pushTarget(out, seen, { activityId: key.slice('activity:'.length) });
      } else {
        pushTarget(out, seen, { shapeId: key });
      }
      continue;
    }
    pushTarget(out, seen, item);
  }
  return out;
}
